export const environment = {
  production: true,
  xdebug: false,
  apiUrl: 'https://api.crm.alpha.lionflence.com/api',
  cdnUrl: 'https://api.crm.alpha.lionflence.com',
  ssoUrl: 'https://sso.lionflence.com',
  mercureUrl: 'https://api.crm.alpha.lionflence.com/sse',
  locale: 'de',
  vapid_public_key: 'BJ8ZBSu0uiHnKgTX9WQV86ri8rAERmzj88C34udlSuxA6noGpIzzBBFqacO6JEoJftIcYVM91ulehrZk3-1X75Q'
};
